import React from 'react'

const t = {
    FR: {
        specifics_footerPrivacy: {'page title': 'Politique de confidentialité',},
        'subtitle 1': <>Pour avoir un compte Incohérences, ces informations sont nécessaires&nbsp;:</>,
        'bulletList 1': <ul>
            <li>
                Un pseudonyme (peut être votre nom ou n'importe quel mot).
            </li>
            <li>
                Un mot de passe complexe.
            </li>
            <li>
                Trois icône de couleur à mémoriser.
            </li>
        </ul>,

        'subtitle 2': <>Aucune information n'est collectée à votre insu.</>,
        'text 1': <>Vous pouvez consulter, télécharger et effacer l'ensemble des données associées à votre compte.<br />
            <span className='smallItalic'>&nbsp;&nbsp;&nbsp;(Cette fonction est à venir)</span></>,
    },
    EN: {
        specifics_footerPrivacy: {'page title': 'Privacy Policy',},
        'subtitle 1': <>To have an Incohérences account, this information is required:</>,
        'bulletList 1': <ul>
            <li>
                A pseudonym (can be your name or any word).
            </li>
            <li>
                A complex password.
            </li>
            <li>
                Three colored icons to remember.
            </li>
        </ul>,

        'subtitle 2': <>No information is collected without your knowledge.</>,
        'text 1': <>You can view, download and delete all data associated with your account.<br />
            <span className='smallItalic'>&nbsp;&nbsp;&nbsp;(This feature is coming soon)</span></>,
    },
    ES: {
        specifics_footerPrivacy: {'page title': 'Política de privacidad',},
        'subtitle 1': <>Para tener una cuenta de Incohérences es necesaria esta información:</>,
        'bulletList 1': <ul>
            <li>
                Un seudónimo (puede ser tu nombre o cualquier palabra).
            </li>
            <li>
                Una contraseña compleja.
            </li>
            <li>
                Tres íconos de colores para recordar.
            </li>
        </ul>,

        'subtitle 2': <>No se recopila ninguna información sin su conocimiento.</>,
        'text 1': <>Puede ver, descargar y eliminar todos los datos asociados con su cuenta.<br />
            <span className='smallItalic'>&nbsp;&nbsp;&nbsp;(Esta función estará disponible próximamente)</span></>,
    },
    PT: {
        specifics_footerPrivacy: {'page title': 'Política de privacidade',},
        'subtitle 1': <>Para ter uma conta no Incohérences, essas informações são necessárias:</>,
        'bulletList 1': <ul>
            <li>
                Um nome de usuário (pode ser seu nome ou qualquer outra palavra).
            </li>
            <li>Uma senha complexa</li>
            <li>Três ícones coloridos para lembrar.</li>
        </ul>,

        'subtitle 2': <>Nenhuma informação é coletada sem o seu conhecimento.</>,
        'text 1': <>
            Você pode visualizar, fazer download e excluir todos os dados associados
            à sua conta.
            <br />
            <span className='smallItalic'>
                &nbsp;&nbsp;&nbsp;(Essa funcionalidade será disponibilizada em breve)
            </span>
        </>,
    },
}

export default t